{
	"header": {
		"tag": "Tilisi",
		"title": "Viestit"
	},
	"empty": {
		"title": "Ei viestejä vielä",
		"description": "Kun otat yhteyttä myyjään tai saat viestin, se näkyy täällä.",
		"browse": "Selaa ilmoituksia"
	},
	"conversation": {
		"buyingFrom": "Ostan:",
		"sellingTo": "Myyn:",
		"viewListing": "Näytä ilmoitus →"
	},
	"panel": {
		"yourConversation": "Keskustelusi",
		"contactSeller": "Ota yhteyttä myyjään",
		"viewMessages": "Näytä viestit",
		"re": "Asia:"
	},
	"compose": {
		"willingToBuy": "Halukas ostamaan",
		"willingToBuyTitle": "Halukas ostamaan",
		"willingToBuyDescription": "Lähetä 'olen kiinnostunut' -viesti välittömästi",
		"makeOffer": "Tee tarjous",
		"makeOfferTitle": "Tee tarjous",
		"makeOfferDescription": "Ehdota omaa hintaasi",
		"askQuestion": "Kysy kysymys",
		"askQuestionTitle": "Kysy kysymys",
		"askQuestionDescription": "Kunnosta, toimituksesta ja muusta",
		"yourOffer": "Tarjouksesi",
		"priceNegotiable": "Myyjä on merkinnyt tämän hintaneuvoteltavaksi.",
		"sendOffer": "Lähetä tarjous",
		"back": "← Takaisin",
		"whatToAsk": "Mitä haluaisit kysyä?",
		"send": "Lähetä",
		"willingToBuyTemplate": "Hei! Olen kiinnostunut ostamaan tämän kiekon. Onko se vielä saatavilla?",
		"makeOfferTemplate": "Hei! Haluaisin tarjota {{price}} € tästä kiekosta. Käykö se?"
	},
	"thread": {
		"writeReply": "Kirjoita vastaus…",
		"keyboardHint": "↵ lähetä · ⇧↵ uusi rivi",
		"sendReply": "Lähetä vastaus"
	}
}
